// Environment detection based on hostname.
//
// Hostname-based detection (no build-time env vars needed):
//
// PRODUCTION (serves real users, talks to prod Railway API):
//   - pop.warehouse-mx.com
//   - wh-pop.pages.dev                                     (legacy Pages alias)
//   - wh-pop-platform.jose-ae8.workers.dev                 (Worker prod alias)
//
// STAGING (preview deploys, talks to staging Railway API):
//   - stagingv2-pop.warehouse-mx.com                       (custom domain canonico)
//   - wh-pop-platform-staging.jose-ae8.workers.dev         (Worker staging alias)
//   - develop-wh-pop-platform-staging.jose-ae8.workers.dev (branch alias)
//   - <hash>-wh-pop-platform-staging.jose-ae8.workers.dev  (per-version preview)
//   - any other *.jose-ae8.workers.dev (non-production versions/Workers)
//   - any other *.wh-pop.pages.dev subdomain (legacy Pages preview)
//
// DEVELOPMENT:
//   - localhost / 127.0.0.1 / *.local
//
// Historia (2026-05-06): el dominio viejo era staging-pop.warehouse-mx.com
// y vivia en el MISMO Worker que prod (no era staging real). Se migro a
// stagingv2-pop.warehouse-mx.com en un Worker SEPARADO `wh-pop-platform-staging`
// con su propio backend (Railway env staging). El nombre "v2" es por el cambio
// de Worker, no porque haya un v3 — quedo como permanente.
//
// Why hostname-based: Cloudflare Workers/Pages unified UI no longer splits
// build env vars by Production vs Preview, so we can't rely on
// REACT_APP_ENV / REACT_APP_API_URL set per-environment.

const PROD_API_URL = 'https://wh-pop-platform-production.up.railway.app';
const STAGING_API_URL = 'https://wh-pop-platform-staging.up.railway.app';

const PRODUCTION_HOSTNAMES = new Set([
  'pop.warehouse-mx.com',
  'wh-pop.pages.dev',
  'wh-pop-platform.jose-ae8.workers.dev',
]);

export function getEnvironment() {
  if (typeof window === 'undefined') return 'production';
  const host = window.location.hostname.toLowerCase();

  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
    return 'development';
  }

  if (PRODUCTION_HOSTNAMES.has(host)) return 'production';

  // Anything else on our preview domains = staging.
  // Cloudflare Workers preview versions get URLs like:
  //   wh-pop-platform-staging.jose-ae8.workers.dev      (Worker alias)
  //   <hash>-wh-pop-platform-staging.jose-ae8.workers.dev (per-version)
  // Custom staging domain: stagingv2-pop.warehouse-mx.com (desde 2026-05-06).
  if (host === 'stagingv2-pop.warehouse-mx.com') return 'staging';
  if (host.endsWith('.jose-ae8.workers.dev')) return 'staging';
  if (host.endsWith('.wh-pop.pages.dev')) return 'staging';

  // Unknown hostname: default to production to avoid accidentally writing to
  // staging DB from an unexpected domain.
  return 'production';
}

export function getApiBaseUrl() {
  const env = getEnvironment();
  if (env === 'staging') return STAGING_API_URL;
  if (env === 'development') {
    return process.env.REACT_APP_API_URL || 'http://localhost:8000';
  }
  return PROD_API_URL;
}
